import { Navigate, useLocation } from 'react-router-dom'
import { movedPath } from './movedPaths'

/** Sends an address from before the Updates area to the same page under /updates. */
export function MovedToUpdates() {
  const location = useLocation()
  const target = movedPath(location.pathname) ?? '/'
  return <Navigate to={`${target}${location.search}${location.hash}`} replace />
}
